<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" >
    </div>
</template>


<script>

    export default {
        data() {
            return {
            }
        },
        mounted() {
            let url = `/auth/google/callback${window.location.search}`;
            this.$axios.get(url).then(res => {
                if (res.data && res.data.jwt && res.data.user) {
                    localStorage.setItem("jwt", res.data.jwt);
                    this.$store.commit("setState", {user: res.data.user});
                    this.$axios.defaults.headers["Authorization"] = "Bearer " + res.data.jwt;
                    if (/us/i.test(res.data.user.email)) {
                        this.$router.push("/global-search-lm");
                    } else if (res.data.user.role === "Authenticated") {
                      this.$router.push("/global-search");
                    } else {
                      this.$router.push(localStorage.getItem('loginRedirect') || "/");
                    }
                    localStorage.removeItem('loginRedirect');
                } else {
                    this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Login error!', text: res.data.error ? res.data.error : "Unknown Error!", time: 5000});
                    this.$router.push("/login")
                }
            }).catch(e => {
                console.log('error', e)
            })

        },
        methods: {
        }
    }
</script>

<style lang="scss">
    .login-tabs-container {
        min-height: 505px;

        .con-tab {
            padding-bottom: 14px;
        }

        .con-slot-tabs {
            margin-top: 1rem;
        }
    }
</style>
